import { Alert as AntAlert, type AlertProps as AntAlertProps } from 'antd';
import classNames from 'classnames';
import React, { memo } from 'react';

import './Alert.less';

type AlertProps = {
  icon?: AntAlertProps['icon'];
  message: AntAlertProps['message'];
  /** Default to 'error' */
  type?: 'critical' | 'error' | 'neutral' | 'warning';
};

const mapTypeToAntType = (type: AlertProps['type']): AntAlertProps['type'] => {
  switch (type) {
    case 'neutral':
      return 'info';
    case 'critical':
      return 'error';
  }
  return type;
};

function Alert({ type = 'error', icon, ...rest }: AlertProps): JSX.Element {
  const mergedClassName = classNames(
    { 'Alert--neutral': type === 'neutral' },
    { 'Alert--critical': type === 'critical' }
  );
  return (
    <AntAlert
      type={mapTypeToAntType(type)}
      className={mergedClassName}
      icon={icon}
      showIcon={!!icon}
      {...rest}
    />
  );
}

export default memo(Alert);
export type { AlertProps };
